import { render, staticRenderFns } from "./TotalProduction.vue?vue&type=template&id=3fb63332&scoped=true"
import script from "./TotalProduction.vue?vue&type=script&lang=js"
export * from "./TotalProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb63332",
  null
  
)

export default component.exports